import { NumericControl } from "./index.styled";
export default NumericControl;
